import styled from 'styled-components'
import { Colors } from '../../commons/Theme'

export const StyledSingleVimeoPlayer = styled.div`
  background-color: ${(props) => props.isWhite ? Colors.white : Colors.black};
`
